import React from 'react';
import { isEmpty } from 'lodash';
import { Stack } from '@fiverr-private/layout_components';
import { FreelancerPreferences } from '@fiverr-private/dynamic_matching';
import { GeneratedContent } from '../GeneratedContent';
import { AttachmentsGallery } from '../AttachmentsGallery';
import { BudgetAndTimeline } from '../BudgetAndTimeline';
import { ServiceOptions } from '../ServiceOptions';
import { ScreeningQuestions } from '../ScreeningQuestions';
import type { SellerBriefResponse } from '../../../types/SellerBriefResponse';

interface BriefDescriptionProps extends SellerBriefResponse {
  scope: 'seller' | 'buyer';
}

export const BriefDescription = ({
  budgetInCents,
  subCategoryId,
  nestedSubCategoryId,
  metadataAnswers,
  attachments,
  content,
  deliveryDate,
  pricingType,
  timeline,
  needType,
  needTypeDetails,
  budgetRangeInCents,
  timelineDetails,
  originalBuyerBudget,
  originalBuyerBudgetRange,
  scope,
  viewSeller,
  screeningQuestions,
}: BriefDescriptionProps) => {
  const { freelancerPreferences } = metadataAnswers || {};
  const showScreeningQuestions = screeningQuestions && screeningQuestions.length > 0;
  const showFreelancerPreferences =
    !isEmpty(freelancerPreferences) &&
    Object.values(freelancerPreferences).some((value) => value !== null && !isEmpty(value));

  return (
    <Stack direction="column" gap="8" withDivider={true}>
      <Stack direction="column" gap="8" maxWidth="694px">
        <GeneratedContent
          generatedContent={content?.generatedContent}
          needType={needType}
          needTypeDetails={needTypeDetails}
        />
        <ServiceOptions
          metadataAnswers={metadataAnswers}
          subCategoryId={subCategoryId}
          nestedSubCategoryId={nestedSubCategoryId}
        />
        <AttachmentsGallery attachments={attachments} />
      </Stack>
      <BudgetAndTimeline
        needType={needType}
        timeline={timeline}
        budgetInCents={budgetInCents}
        deliveryDate={deliveryDate}
        pricingType={pricingType}
        budgetRangeInCents={budgetRangeInCents}
        timelineDetails={timelineDetails}
        originalBuyerBudget={originalBuyerBudget}
        scope={scope}
        originalBuyerBudgetRange={originalBuyerBudgetRange}
      />
      {showScreeningQuestions && <ScreeningQuestions screeningQuestions={screeningQuestions} scope={scope} />}
      {showFreelancerPreferences && (
        <FreelancerPreferences preferences={freelancerPreferences} viewType={scope} seller={viewSeller} />
      )}
    </Stack>
  );
};
